import type { ICustomer } from '@/types/core/Customer'

export function getCustomerDisplayName(customer: ICustomer): string {
  if (customer.company_name) {
    return customer.company_name
  } else if (customer.first_name && customer.last_name) {
    return `${customer.first_name} ${customer.last_name}`
  } else {
    return customer.email ?? customer.id
  }
}
